import { useMemo } from 'react';

const useSchedule = ({ schedule } : { schedule?: string }) => {
  const parsedSchedule = useMemo(() => {
    let scheduleUnit;
    let dayOfMonthOption;
    let minute;
    let hour;
    let month;
    let scheduleCount;
    let dayOfWeek;
    let dayOfMonth;

    let match;

    if (schedule) {
      const scheduleParts = schedule.split(" ");

      minute = scheduleParts[0];
      hour = scheduleParts[1];

      if (match = scheduleParts[2].match(/^\*\/([0-9]+)$/)) {
        scheduleUnit = "days";
        scheduleCount = match[1];
      }
      else if (match = scheduleParts[4].match(/^([0-9]+)%([0-9]+)$/)) {
        scheduleUnit = "weeks";
        dayOfWeek = match[1];
        scheduleCount = match[2];
      }
      else if (match = scheduleParts[3].match(/^\*\/([0-9]+)$/)) {
        scheduleUnit = "months";
        scheduleCount = match[1];

        if (scheduleParts[2] === '1') {
          dayOfMonthOption = 'first';
        }
        else if (scheduleParts[2] === 'L') {
          dayOfMonthOption = 'last';
        }
        else  {
          dayOfMonthOption = 'custom';
          dayOfMonth = scheduleParts[2];
        }
      }
      else if (scheduleParts[2].match(/^[0-9]+$/) && scheduleParts[3].match(/^[0-9]+$/)) {
        scheduleUnit = "years";
        dayOfMonth = scheduleParts[2];
        month = (Number(scheduleParts[3]) - 1).toString();
      }
    }

    return ({
      scheduleUnit,
      dayOfMonthOption,
      minute,
      hour,
      month,
      scheduleCount,
      dayOfWeek,
      dayOfMonth
    });
  }, [schedule]);

  return (parsedSchedule);
}

export default useSchedule;
